<template>
			<div id="page-content">
				<div id="log-in"  style="background: url('static/images/l.jpg') no-repeat center center; background-size: cover;">
				
					<div id="supplierinfo" class="col-md-8">
						<h1>Buyer Registration</h1>
						<p>this template currently applies for buyers</p>
						<ul>
							<li>Buy Apollo lighting fixture products</li>
							<li>Get notifications reports about the products</li>
						</ul>
					</div>
					
					<div id="register" class="col-md-4">
						<h1>Sign Up!</h1>
						<form v-on:submit.prevent="buyerRegister">
							<h3>Account Information</h3>
							
							<label for="name">Full name</label>

							<!-- experiment time -->
							<!-- <span style="color: red; margin-bottom: 0;">user name is required</span> -->
							<!-- experiment time -->

							<input type="text" name="name" id="name" placeholder="Full name" />
							
							<label for="username">Username</label>
							<input type="text" name="username" id="username" placeholder="username" />
							
							<label for="email">Email</label>
							<input type="text" name="email" id="email" placeholder="email" />
							
							<label for="password">Password</label>
							<input type="password" name="password" id="password" placeholder="password" />
							
							<label for="password_confirm">Confirm Password</label>
							<input type="password" name="password_confirm" id="password_confirm" placeholder="Confirm Password" />

							<label for="mobile_number">Mobile Number</label>
							<input type="text" name="mobile_number" id="mobile_number" placeholder="Mobile Number">
							
							<input type="hidden" name="token" :value="token" />

							<button type="submit">Register</button>
							<div id="message" style="padding: 10px 0;"></div>
						</form>
					</div>
					
				</div>
			</div>
</template>

<script>
	//CHECK SESSION AGAIN IF POSSIBLE
	export default{
		props: ['issessionset'],
		data(){
			return{
				token: ''
			}
		},
		methods: {
			buyerRegister: function(event){
				var self = this;
				var data = $(event.target).serialize();
				$.ajax({
					url: 'static/php/userregistration.php',
					type: 'post',
					data: data,
					success: function(data){
						if(data === 'ok'){
							self.$router.push({path: '/login'});
						}else{
							$('#message').html(data);
							$.ajax({
								url: 'static/php/gettoken.php',
								success: function(data){
									if(typeof data === "string"){
										self.token = data;
									}
								}
							});
						}
					}
				});
			}
		},
		created(){
			var self = this;
			if(this.issessionset === true){
				this.$router.push({ path: '/user' });
			}else{
				$.ajax({
					url: 'static/php/gettoken.php',
					success: function(data){
						if(typeof data === "string"){
							self.token = data;
						}
					}
				});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			issessionset: function(newval){
				if(newval === true){
					this.$router.push({ path: '/user' });
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Buyer.vue?0ab780b4